import React, { useState, useEffect, useCallback } from 'react';
import logo2 from '../../images/analyticsLogo.png';
import { Link, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setSessionUserActiveCAS, sendGADimensions } from '../../actions/Users/UserAction';
import { getCohortsOrganizations } from '../../actions/Cohort/CohortAction';
import { getPageHeaderZIndex, getReportMenu, getReportLink } from '../../actions/Page/PageAction';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import DDMCasOrganization from './DDMCasOrganization';
import CasOrgsInstitutionDetails from './CasOrgsInstitutionDetails';
import MainNav from './MainNav';
import {
  ADMINISTRATOR_USER,
  ASSOCIATION_USER,
  INSTITUTION_USER,
  REPORT_USER,
  SPECIALTY_USER,
  SUPER_USER,
} from '../../actionTypes/Users/UserActionType';
import { setSrLoadedMsg } from '../../actions/Notifications/ScreenReaderInit';
import { identity } from 'ramda';
import withNavigate from '../HOC/navigate';
const urlSubField = ['submitted applicants by month with user-defined cohort'];
const HeaderAuth = (props) => {
  const {
    casDetails,
    reportMenus,
    loggedUserDetails,
    navigate,
    setSessionUserActiveCAS,
    setSrLoadedMsg,
    getPageHeaderZIndex,
    userCasOrgs,
    userCasOrgsLoading,
    impersonating,
    userInstitutionName,
  } = props;

  const [dropdown, setDropdown] = useState(false);
  const [selectedNewCas, setSelectedNewCas] = useState(false);
  const location = useLocation();
  useEffect(() => {
    if (reportMenus.dashboard.reportURL !== undefined && selectedNewCas) {
      setSelectedNewCas(false);
      //navigate('/');
    }
  }, [reportMenus.dashboard.reportURL, selectedNewCas]);

  useEffect(() => {
    console.log('... ');
  }, []);
  const toggleDropdown = (state) => {
    getPageHeaderZIndex(true);
    setDropdown(!state);
  };

  const selectCas = async (cas) => {
    if (cas.casId !== casDetails.casId) {
      const newCasDetails = {
        casId: cas.casId,
        name: cas.name,
        clientName: cas.clients[0].name,
        clientId: cas.clients[0].id,
      };

      if (!impersonating) {
        sendGADimensions(loggedUserDetails.userPrincipalId, newCasDetails.name);
      }
      await getReportMenu(cas.clients[0].id);
      setSessionUserActiveCAS(newCasDetails);
      setSrLoadedMsg(`Dashboard frame for ${newCasDetails.name}`);
      setSelectedNewCas(true);

      // navigate('/');
    }

    toggleDropdown(true);
  };

  const renderCAS = useCallback(() => {
    if (!userCasOrgs.length) return null;
    return userCasOrgs.map((cas, index) => (
      <DropdownItem
        key={index}
        onKeyDown={({ key }) => key === 'Enter' && selectCas(cas)}
        onClick={() => selectCas(cas)}
        className={casDetails.name === cas.name ? 'active' : ''}>
        {cas.name}
      </DropdownItem>
    ));
  }, [userCasOrgs, casDetails.name]);

  const onSelectOrganization = async (cas) => {
    const { getReportMenu, reportLinkObj, getReportLink, getCohortsOrganizations } = props;
    if (!impersonating) {
      sendGADimensions(loggedUserDetails.userPrincipalId, cas.name, cas.clientName, userInstitutionName);
    }

    await setSessionUserActiveCAS(cas);
    await setSelectedNewCas(true);
    await getReportMenu(cas.clientId);
    setSrLoadedMsg(`Dashboard frame for ${cas.name} ${cas.clientName}`);
    const queryParams = new URLSearchParams(location?.search);
    // The Following if block is to check the URL for the sub field and if it matches , then
    //we need to reload cohort setting page (BUG FIX of NF-77139)

    if (urlSubField.includes(queryParams.get('sub')?.toLowerCase())) {
      let report = {
        ...reportLinkObj,
        filterByCohort: true,
      };
      getReportLink(report);
      getCohortsOrganizations(cas.casId);
    }
    if (window.location.pathname.includes('/report')) navigate('/reports' + window.location.search);
  };

  const getHeaderContent = () => {
    switch (loggedUserDetails.userRole) {
      case INSTITUTION_USER:
        return <CasOrgsInstitutionDetails />;
      case REPORT_USER:
      case ADMINISTRATOR_USER:
        return (
          <DDMCasOrganization
            onSelectOrganization={onSelectOrganization}
            selectedCasDetails={casDetails}
            casOrganizations={userCasOrgs}
            loading={userCasOrgsLoading}
          />
        );
      case SPECIALTY_USER:
        if (props.previewUser)
          return <h5 className="speciality-title">{props?.previewUser?.casOrgs[0]?.clients[0]?.name}</h5>;
        else if (props.loggedUserDetails.userRole === SPECIALTY_USER)
          return <h5 className="speciality-title">{props?.userCasOrgs[0]?.clients[0]?.name}</h5>;
        else return <h5 className="speciality-title">N.A.</h5>;

      case ASSOCIATION_USER:
        return (
          <div className="mLeft-15" style={{ flex: 1 }}>
            {casDetails.name && userCasOrgs && (
              <Dropdown
                isOpen={dropdown}
                className={`headerCas ${userCasOrgs.length === 1 ? 'dropdown-disabled' : ''}`}
                toggle={() => toggleDropdown(dropdown)}>
                <DropdownToggle>
                  {casDetails.name}
                  {userCasOrgs.length > 1 && <i className="fa fa-caret-down mLeft-5" />}
                </DropdownToggle>
                <DropdownMenu tabIndex={dropdown ? '0' : '-1'} className="dropDown-absolute">
                  {dropdown ? renderCAS() : []}
                </DropdownMenu>
              </Dropdown>
            )}
            <span className="show fontSm-20 line-height-20">{casDetails.clientName}</span>
          </div>
        );
      default:
        return null;
    }
  };

  const casOrgDropdown = getHeaderContent();

  return (
    <React.Fragment>
      <header className={[...(props.classNames || []), 'app-header-auth'].filter(identity).join(' ')}>
        {props.children}
        <div className="logo-container">
          <Link to={loggedUserDetails.userRole !== SUPER_USER ? '/' : '/users'}>
            <img src={logo2} className="App-logo" alt="Analytics by Liaison link" />
          </Link>
        </div>
        <div
          className={['header-controls-wrapper', !!casOrgDropdown ? 'has-dropdown' : null].filter(identity).join(' ')}>
          {casOrgDropdown}
          <MainNav />
        </div>
      </header>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  impersonating: state.Impersonate.impersonate.userPersonated,
  userCasOrgs: state.AppSession.institutionDetails.casOrgs,
  userCasOrgsLoading: state.AppSession.institutionDetailsLoading,
  userInstitutionName: state.AppSession.institutionDetails.institutionName,
  casDetails: state.AppSession.activeCasDetails,
  reportMenus: state.Page.reportMenus,
  loggedUserDetails: state.AppSession.userDetails,
  previewUser: state.Users.previewUser,
  reportLinkObj: state.Page.reportLink,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setSessionUserActiveCAS,
      getPageHeaderZIndex,
      setSrLoadedMsg,
      getReportMenu,
      getReportLink,
      getCohortsOrganizations,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(withNavigate(HeaderAuth));
